import { createSelector } from '@ngrx/store';
import { getSalesState } from '../sales.reducers';
import * as fromStackDiscountReducer from './stack-discount.reducer';

export const selectStackDiscount = createSelector(getSalesState, (state) => state.stackDiscount);

export const selectStackDiscountData = createSelector(selectStackDiscount, fromStackDiscountReducer.getStackDiscount);
export const selectErrors = createSelector(selectStackDiscount, fromStackDiscountReducer.getErrors);
